import { createRoot } from 'react-dom/client'
import './index.css'
import { App } from '@src/App'
import { isProd } from '@src/utils/is-prod'

createRoot(document.querySelector('#root')!).render(<App />)

// Load Sentry after first paint so its ~25KB gz stays out of the entry chunk.
if (import.meta.env.MODE !== 'development') {
  const initSentry = () =>
    import('@sentry/react').then((Sentry) => {
      Sentry.init({
        dsn: 'https://0d5cae6b186745fba2fcad541c29d302@o128985.ingest.sentry.io/6519066',
        environment: isProd ? 'production' : 'sandbox',
        ignoreErrors: ['ResizeObserver'],
      })
    })

  if ('requestIdleCallback' in window) requestIdleCallback(initSentry)
  else setTimeout(initSentry, 0)
}
